define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');

    var version = 0.9;

    window.liveperson = window.liveperson || {};
    window.liveperson.uiframework = window.liveperson.uiframework || {};
    window.liveperson.uiframework.latest = window.liveperson.uiframework.latest || {};

    var uiframeworkNamespace = window.liveperson.uiframework;
    uiframeworkNamespace["v" + version] = uiframeworkNamespace["v" + version] || {};
    uiframeworkNamespace = uiframeworkNamespace["v" + version];

    var util = window.lpTag && window.lpTag.taglets && window.lpTag.taglets.lpUtil;
    var logger = window.lpTag && window.lpTag.unifiedWindow && window.lpTag.unifiedWindow.log;

    uiframeworkNamespace.LPModel = uiframeworkNamespace.LPModel || function (defaults, log) {
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            if ("object" === typeof log) {
                logger = log;
            }
            if (!logger || true === log) {
                logger = {
                    error: _createLogFunc("ERROR"),
                    warn: _createLogFunc("WARN"),
                    info: _createLogFunc("INFO"),
                    debug: _createLogFunc("DEBUG")
                };
            }

            function _createLogFunc(level) {
                return function (message) {
                    if (true === log && window.console) {
                        if (level === "ERROR" && window.console.error) {
                            window.console.error("LPModel#" + level + " : " + message + ", " + _getLogDateTime());
                        }
                        else if (window.console.log) {
                            window.console.log("---LPModel#" + level + " : " + message + ", " + _getLogDateTime());
                        }
                    }
                };
            }

            function _getLogDateTime() {
                var now = new Date();
                var fixTime = function (num) {
                    return (num < 10) ? "0" + num : num;
                };
                var dateStr = fixTime(now.getHours()) + ":" + fixTime(now.getMinutes()) + ":" + fixTime(now.getSeconds()) + ", " + now.toDateString() + ", (" + now.getTime() + ")";
                return dateStr;
            }

            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            var Model = function (defaultValues) {
                this.attributes = defaultValues || {};
                this.keysMap = {};

                /**
                 * This is the bind function of the model
                 * @param key - The key you bind to
                 * @param callback - The callback function to run when trigger
                 * @param context - The context to run the callback function
                 * @param deepBind - Allows get trigger for child's changes (defaults: false)
                 */
                this.on = function (key, callback, context, deepBind) {
                    var indexOfValue = key.indexOf("(");
                    var value;
                    if (indexOfValue >= 0) {
                        value = key.substring(indexOfValue + 1, key.length - 1);
                        key = key.substring(0, indexOfValue);
                    }

                    var array = this.keysMap[key] || (this.keysMap[key] = []);
                    // Check that this combinations is not already in the keysMap array. if it is, then break out of the function without adding it again.
                    for (var i = 0; i < array.length; i++){
                        if (array[i].key === key &&
                            array[i].callback === callback &&
                            array[i].context === context &&
                            array[i].specificValue === value &&
                            array[i].deepBind === deepBind
                        ) {
                            var text ="Duplicate on request or key[" + key + "]";
                            if (callback) {
                                text += " with callback: " + callback.toString();
                            }
                            if (context) {
                                var name;
                                if (context.ControllerName) {
                                    name = context.ControllerName;
                                } else if (context.applicationType) {
                                    name = context.applicationType;
                                }
                                if (name) {
                                    text += " in context: " + name;
                                }
                            }

                            logger.debug(text, "LPModel.on");

                            return;
                        }
                    }
                    array.push({
                        key: key,
                        callback: callback,
                        context: context,
                        specificValue:value,
                        deepBind:deepBind
                    });
                };

                this.off = function (key, callback, context) {
                    var indexOfValue = key ? key.indexOf("(") : -1;
                    var value;
                    if (indexOfValue >= 0) {
                        value = key.substring(indexOfValue + 1, key.length - 1);
                        key = key.substring(0, indexOfValue);
                    }

                    var keysArray = key ? [key] : _collectKeys(this.keysMap);
                    var bindArray, newBindArray, bindIndex, data, i;

                    for (i = 0; i < keysArray.length; i++) {
                        bindArray = this.keysMap[keysArray[i]];

                        if (bindArray && bindArray.length > 0) {
                            newBindArray = [];
                            for (bindIndex = 0; bindIndex < bindArray.length; bindIndex++) {
                                data = bindArray[bindIndex];
                                if (!_match(key, data.key) ||
                                    !_match(callback, data.callback) ||
                                    !_match(context, data.context)) {
                                    if ("undefined" === typeof data.specificValue || (data.specificValue && data.specificValue === "" + value)) {
                                        newBindArray.push(bindArray[bindIndex]);
                                    }
                                }
                            }
                            this.keysMap[keysArray[i]] = newBindArray;
                        }
                    }
                };
                /**
                 * Trigger callbacks for the given event. Subsequent arguments to trigger will be passed along to the event callbacks.
                 * @param key
                 * @param value
                 */
                this.trigger = function (key, value) {
                    // Trigger the key
                    _trigger(this.keysMap, key, value);

                    // Check if this trigger is not from the parent and start deep bind triggering
                    if (!value.parentTrigger) {
                        var splitKey = key.split(".");
                        var tempKey = "";
                        // forloop the key path and call _trigger for each parent
                        for (var j = 0; j < splitKey.length - 1; j++) {
                            if (tempKey !== "") {
                                tempKey += ".";
                            }
                            tempKey += splitKey[j];
                            _trigger(this.keysMap, tempKey, value, true);
                        }
                    }

                };
                // private function of trigger
                function _trigger(keysMap, key, value, deepBind){
                    var curKeyItem;
                    var keysArray = keysMap[key];
                    if(keysArray) {
                        for (var i = 0; i < keysArray.length; i++) {
                            try {
                                curKeyItem = keysArray[i];
                                if (deepBind !== true || (deepBind === true && curKeyItem.deepBind === true)) { // if no deep bind or if deep bind and callback is also deep bind.
                                    if (curKeyItem.deepBind !== true || true !== value.parentTrigger) { // not deep bind or not  parentTrigger
                                        if ("undefined" === typeof curKeyItem.specificValue || // if no specificValue or the specificValue is the one that modify
                                            curKeyItem.specificValue === "" + value.newValue) {
                                            curKeyItem.callback.call(curKeyItem.context || this, value);// _cloneExtend(value, null, true));
                                        }
                                    }
                                }
                            }
                            catch (e) {
                                if(lpTag.WebAgent.logicController.isDevEnvironment()) {
                                    throw e;
                                }

                                logger.error("Triggering key[" + key + "]", "trigger");
                            }
                        }
                    }
                }
                function _match(key, value) {
                    return !key || key === value;
                }

                function _collectKeys(fromMap) {
                    return _.keys(fromMap);
                }

                this.toJSON = function () {
                    return _stringify(this.attributes);
                };

                this.reset = function () {
                    if (this.keysMap && this.keysMap.length) {
                        for (var i = 0; i < this.keysMap.length; i++) {
                            var obj = this.keysMap[i];

                            // Nullify the bastard
                            obj.callback = null;
                            delete obj.callback;
                        }
                    }

                    this.keysMap.length = 0;
                    this.attributes = {};
                };
            };

            var debugging = defaults && "boolean" === typeof defaults.debugging ? defaults.debugging : false;

            var model = new Model(defaults);
            //    var ModelExtend = Backbone.Model.extend({defaults : defaults});
            //    var model = new ModelExtend();

            this.setDebugMode = function (enabled) {
                debugging = enabled;
            };

            this.getModel = function () {
                return model;
            };

            // TODO: Remove currently does not trigger a remove on all inner properties
            this.removeKey = function (key, triggerRemove) {
                var splitKey = key && key.path || key;

                var removedObject;
                var keysArray = splitKey.split(".");

                if (model.attributes[keysArray[0]]) {
                    var keysLength = keysArray.length;
                    if (keysLength === 1) {//Key is only one, example: agent
                        removedObject = model.attributes[keysArray[0]];
                        _deleteKey(keysArray[0], model.attributes);
                    }
                    else {
                        var json = model.attributes[keysArray[0]];
                        for (var i = 1; i < keysLength; i++) {
                            if (i == keysLength - 1) {
                                removedObject = json[keysArray[i]];
                                _deleteKey(keysArray[i], json);
                            }
                            else {
                                if (json[keysArray[i]]) {
                                    json = json[keysArray[i]];
                                }
                                else {
                                    logger.debug("Key doesn't exist, key: " + key, "LPModel.removeKey");
                                    break;
                                }
                            }
                        }
                    }

                    if ("undefined" !== typeof removedObject &&
                        ("undefined" === typeof triggerRemove || triggerRemove)) {
                        model.trigger("change:" + key, {
                            key: key,
                            removedValue: removedObject
                        });
                        removedObject = null;
                    }
                }
                else {
                    logger.debug("Root key doesn't exist, key: " + key, "LPModel.removeKey");
                }

                function _deleteKey(key, json) {
                    json[key] = null;
                    delete json[key];
                }
            };

            function _isPrimitive(value) {
                var typeofValue = typeof value;
                return typeofValue === "number" ||
                    typeofValue === "boolean" ||
                    typeofValue === "string" ||
                    typeofValue === "function" ||
                    (value.nodeType && value.nodeType === 1) ||
                    value instanceof Date; // value is a DOM element, treat it as a primitive.
            }

            this.set = function (key, value) {
                var splitKey = key && key.path || key;
                var dataObj = {};
                dataObj.oldValue = this.get(splitKey);
                dataObj.value = value;
                this.removeKey(splitKey, "undefined" === typeof value); // Only triggering remove on "undefined" set.
                this.modify(splitKey, dataObj);
            };

            this.modify = function (splitKey, updateData, uniqueArrayId, silent) {
                var modifyPath = splitKey && splitKey.path || splitKey;

                var triggeringArray = [];
                var triggeringArrayKeyMap = {};
                var oldValue;

                if (updateData && typeof updateData.oldValue !== "undefined") {
                    oldValue = updateData.oldValue;
                    updateData = updateData.value;
                } else {
                    oldValue = lpUtils.cloneObject(this.get(modifyPath));
                }

                var returned = _buildJSONfromKeyObjectPair(modifyPath, updateData);
                var oldValueReturn = _buildJSONfromKeyObjectPair(modifyPath, oldValue).data;
                modifyPath = returned.key;
                updateData = returned.data;

                // If the setting data is primitive object.
                var primitiveUpdateData = _isPrimitive(updateData);
                if (!model.attributes[modifyPath] ||
                    primitiveUpdateData) {
                    var previousValue = model.attributes[modifyPath];

                    if (primitiveUpdateData) {
                        if (!previousValue ||
                            previousValue !== updateData) {
                            model.attributes[modifyPath] = updateData;
                            triggeringArray.push({
                                key: modifyPath,
                                value: updateData,
                                oldValue: oldValue
                            });
                        }
                    }
                    else {
                        model.attributes[modifyPath] = Array === updateData.constructor ? [] : {};
                    }
                }

                if (!primitiveUpdateData) {
                    try {
                        _recursiveUpdateModel({
                            objectToModify: model.attributes[modifyPath],
                            complexObject: updateData,
                            triggerKey: modifyPath,
                            triggeringArrayKeyMap: triggeringArrayKeyMap,
                            triggeringArray: triggeringArray,
                            uniqueArrayId: uniqueArrayId,
                            parentTrigger: true,
                            oldValue: oldValueReturn
                        });
                    }
                    catch (exc) {
                        logger.error(modifyPath + " updateData: " + updateData + " error message: " + exc.message, "recursiveUpdateModel");
                    }
                }

                if (!silent) {
                    for (var i = 0; i < triggeringArray.length; i++) {
                        if (debugging) {
                            logger.info("Triggering " + triggeringArray[i].key + " Value: " + triggeringArray[i].value, "modify");
                        }
                        try {
                            model.trigger("change:" + triggeringArray[i].key, {
                                key: triggeringArray[i].key,
                                newValue: triggeringArray[i].value,
                                parentTrigger: triggeringArray[i].parentTrigger,
                                oldValue: triggeringArray[i].oldValue
                            });
                        }
                        catch (exc) {
                            logger.error("Triggering " + triggeringArray[i].key + " Value: " + triggeringArray[i].value + " error message: " + exc.message, "modify");
                        }
                    }
                }
            };
            // Making the key and object as a complex object with a single key
            // For example:
            // Key: chats.chat4444  object: {id:5, data:{type:chatting} }
            // With translate to:
            // key: chats object: {chat4444 : {id:5, data:{type:chatting} } }
            function _buildJSONfromKeyObjectPair(innerKey, innerObject) {
                var keysArray = innerKey.split(".");

                if (1 === keysArray.length) {
                    return {
                        key: innerKey,
                        data: innerObject
                    };
                }

                var jsonObject = innerObject;

                for (var keyIndex = keysArray.length - 1; keyIndex > 0; keyIndex--) {
                    var obj = {};
                    obj[keysArray[keyIndex]] = jsonObject;
                    jsonObject = obj;
                }

                return {
                    key: keysArray[0],
                    data: jsonObject
                };
            }

            function _recursiveUpdateModel(options) {
                options = options || {};

                var objectToModify = options.objectToModify;
                var complexObject = options.complexObject;
                var triggerKey = options.triggerKey;
                var triggeringArrayKeyMap = options.triggeringArrayKeyMap;
                var triggeringArray = options.triggeringArray;
                var uniqueArrayId = options.uniqueArrayId;
                var parentTrigger = options.parentTrigger;
                var oldValue = options.oldValue;
                if (Array === complexObject.constructor && Array === objectToModify.constructor) {
                    //in the case of array the oldValue will by the array without the changes
                    _addToTriggeringMap(triggerKey, complexObject, false, oldValue);
                    _updateArray(objectToModify, complexObject, uniqueArrayId);
                    return;
                }

                for (var prop in complexObject) {
                    if (complexObject.hasOwnProperty(prop)) {
                        if ("undefined" === typeof complexObject[prop] ||
                            null === complexObject[prop]) {
                            logger.debug("Received null value for [" + triggerKey + "] prop [" + prop + "]", "_recursiveUpdateModel");
                            continue;
                        } // TODO: think if we want to ignore undefined or support deleting and firing the value changed.
                        var objectToModifyIsNew = "undefined" === typeof objectToModify[prop];
                        if (objectToModifyIsNew) {
                            _addToTriggeringMap(triggerKey, complexObject, parentTrigger, oldValue);
                            if ("undefined" !== typeof complexObject[prop] &&
                                null !== complexObject[prop]) {
                                objectToModify[prop] = Array === complexObject[prop].constructor ? [] : {};
                            }
                        }
                        if (Array === objectToModify[prop].constructor) {
                            if (Array !== complexObject[prop].constructor) {
                                complexObject[prop] = [complexObject[prop]];
                            }
                            if (complexObject[prop].length > 0 ||
                                objectToModifyIsNew) {
                                var triggerValue = {};
                                triggerValue[prop] = complexObject[prop];
                                _addToTriggeringMap(triggerKey, triggerValue, true, oldValue);
                                if (typeof oldValue !== "undefined" && oldValue !== null) {
                                    _addToTriggeringMap(triggerKey + "." + prop, complexObject[prop], false, oldValue[prop]);
                                } else {
                                    _addToTriggeringMap(triggerKey + "." + prop, complexObject[prop], false, oldValue);
                                }
                            }

                            _updateArray(objectToModify[prop], complexObject[prop], uniqueArrayId);
                        }
                        else if (_isPrimitive(complexObject[prop])) {
                            if (objectToModify[prop] !== complexObject[prop]) {
                                if (!objectToModifyIsNew) {
                                    _addToTriggeringMap(triggerKey, complexObject, true, oldValue);
                                }
                                if (typeof oldValue !== "undefined" && oldValue !== null) {
                                    _addToTriggeringMap(triggerKey + "." + prop, complexObject[prop], false, oldValue[prop]);
                                } else {
                                    _addToTriggeringMap(triggerKey + "." + prop, complexObject[prop], false, oldValue);

                                }
                                objectToModify[prop] = complexObject[prop];
                            }
                        }
                        else {
                            oldValue = (typeof oldValue !== "undefined" && oldValue !== null) ? oldValue[prop] : oldValue;
                            _recursiveUpdateModel({
                                objectToModify: objectToModify[prop],
                                complexObject: complexObject[prop],
                                triggerKey: triggerKey + "." + prop,
                                triggeringArrayKeyMap: triggeringArrayKeyMap,
                                triggeringArray: triggeringArray,
                                uniqueArrayId: uniqueArrayId,
                                parentTrigger: true,
                                oldValue: oldValue
                            });
                        }
                    }
                }
                function _updateArray(objectToModify, complexObject, uniqueArrayId) {
                    if (objectToModify === complexObject || !complexObject || complexObject.length === 0) {
                        return;
                    }

                    if (!uniqueArrayId) {
                        for (var compIndex = 0; compIndex < complexObject.length; compIndex++) {
                            objectToModify.push(complexObject[compIndex]);
                        }
                    }
                    else {
                        _updateArrayWithUniqueArrayId(objectToModify, complexObject, uniqueArrayId);
                    }
                }

                function _updateArrayWithUniqueArrayId(objectToModify, complexObject, uniqueId) {
                    var modifyingMap = {};
                    var value;

                    // Using optimization when the uniqueArrayId actually returns the unique index of the first or second parameter
                    // when called with undefined on either one.
                    // In that case, running once and mapping each object in the parent to uniqueIndex and updating by the second uniqueIndex
                    for (var arrayIndex = 0; arrayIndex < objectToModify.length; arrayIndex++) {
                        value = objectToModify[arrayIndex];
                        modifyingMap[value[uniqueId]] = arrayIndex;
                    }

                    for (var compIndex = 0; compIndex < complexObject.length; compIndex++) {
                        value = complexObject[compIndex];
                        if ("undefined" !== typeof modifyingMap[value[uniqueId]]) {
                            for (var prop in value) { // Updating only incremental change of object and not replacing it.
                                if (value.hasOwnProperty(prop)) {
                                    objectToModify[modifyingMap[value[uniqueId]]][prop] = value[prop];
                                }
                            }
                        }
                        else {
                            objectToModify.push(value);
                        }
                    }
                }

                function _addToTriggeringMap(triggerKey, complexObject, parentTrigger, oldValue) {
                    if (!triggeringArrayKeyMap[triggerKey]) {
                        triggeringArrayKeyMap[triggerKey] = true;
                        triggeringArray.push({
                            key: triggerKey,
                            value: complexObject,
                            parentTrigger: parentTrigger,
                            oldValue: oldValue
                        });
                    }
                }
            }
        };

    function _stringify(obj) {
        if (util && "function" === typeof util.stringify) {
            return util.stringify(obj);
        }
        else {
            return JSON.stringify(obj);
        }
    }

    function _cloneExtend(obj, extendObj, deep) {
        var newObj;

        if (util && "function" === typeof util.cloneExtend) {
            return util.cloneExtend(obj, extendObj, deep);
        }

        if (!obj || "object" !== typeof obj) {
            return obj;
        }

        if (!extendObj) {
            return JSON.parse(_stringify(obj));
        }

        newObj = extendObj || obj.constructor() || {};
        for (var prop in obj) {

            // Prevent never-ending loop
            if (newObj[prop] === obj[prop]) {
                continue;
            }

            if (obj.hasOwnProperty(prop)) {
                newObj[prop] = deep ? _cloneExtend(obj[prop], void 0, deep) : obj[prop];
            }
        }

        return newObj;
    }

    uiframeworkNamespace.LPModel.version = version;
    if (!window.liveperson.uiframework.latest.LPModel || window.liveperson.uiframework.latest.LPModel.version < version) {
        window.liveperson.uiframework.latest.LPModel = uiframeworkNamespace.LPModel;
    }
    /**
     * Bind on changes on a model property
     * @param key - The property key to bind to. (String or array of strings).
     * @param callbackFunc - The callback function to run when trigger.
     * @param context - The context to run the callback function.
     * @param trigger - (optional) Get an event with the property on bind (defaults: true).
     * @param deepBind - (optional) Allows get trigger for child's changes (defaults: false).
    */
    uiframeworkNamespace.LPModel.prototype.bind = function (key, callbackFunc, context, trigger, deepBind) {
        setTimeout(createBindCallback(this, key, callbackFunc, context, trigger, deepBind), 0);

        function createBindCallback(localContext, key, callbackFunc, context, trigger, deepBind) {
            return function() {
                var keyArray = Array.isArray(key) ? key : [key]; // if key is not an array, wrap it with array
                for (var i=0; i < keyArray.length; i++){
                    var splitKey = keyArray[i] && keyArray[i].path || keyArray[i];
                    localContext.getModel().on("change:" + splitKey, callbackFunc, context, deepBind);
                    var value = localContext.get(splitKey);
                    if ("undefined" !== typeof value &&
                        null !== value &&
                        ("undefined" === typeof trigger || trigger)) {
                        callbackFunc.call(context, {
                            key: splitKey,
                            newValue: value,
                            oldValue:null
                        });
                    }
                }
            };
        }
    };

    uiframeworkNamespace.LPModel.prototype.unbind = function (key, callback, context) {
        var splitKey = key && key.path || key;

        if ("undefined" === typeof splitKey ||
            null === splitKey) {
            this.getModel().off(null, null, context);
        }
        else {
            this.getModel().off("change:" + splitKey, callback, context);
        }
    };

    uiframeworkNamespace.LPModel.prototype.toJSON = function () {
        return this.getModel().toJSON();
    };

    uiframeworkNamespace.LPModel.prototype.get = function (key) {
        //TODO: move all keysArray generation to a dedicated function
        var splitKey = key && key.path || key || "";
        var keysArray = splitKey.split(".");

        var model = this.getModel();

        var returnValue = model.attributes;

        for (var i = 0; i < keysArray.length; i++) {
            if (returnValue.hasOwnProperty(keysArray[i])) {
                returnValue = returnValue[keysArray[i]]; // _cloneExtend(returnValue[keysArray[i]], null, true); This had been temporary removed since WA has views inside the model which causes circular reference upon clone
            }
            else {
                returnValue = void 0;
                break;
            }
        }

        if (("undefined" === typeof returnValue) ||
            null === returnValue                 ||
            void 0 === returnValue) {
            returnValue = null;
        }

        return returnValue;
    };

    uiframeworkNamespace.LPModel.createPath = function(path, rootObj, name) {
        var newPath = rootObj ? (rootObj.path + "." + path) : path;
        var pathObj = { path: newPath, name: name };

        pathObj.createPath = function(path) {
            return uiframeworkNamespace.LPModel.createPath(path, pathObj);
        };

        pathObj.inject = function(replaceString) {
            var regex = new RegExp(/_/);
            var newPath = pathObj.path.replace(regex, replaceString);
            return uiframeworkNamespace.LPModel.createPath(newPath);
        };

        return pathObj;
    };

    uiframeworkNamespace.LPModel.prototype.reset = function() {
        return this.getModel().reset();
    };


    return window.liveperson.uiframework.latest.LPModel;

});
